import React, { useState } from "react";
import Button from "../../ui/Button";
import { OptionsState } from "@/types/productModal";
import DecrementIcon from "@/assets/img/DecrementIcon";
import IncrementIcon from "@/assets/img/IncrementIcon";
import ProductDescriptionSection from "./ProductDescriptionSection";
import Scrollbar from "@/components/Scrollbar";
import { AppointmentForm } from "./AppointmentForm";
import { EmployeeThatProvidesThisService } from "@/types/product";
interface ProductOptionsWithButtonProps {
  selectionList: OptionsState;
  shouldShowSurcharge: (surcharge: number) => boolean;
  handleOptionChange: (
    listId: string,
    optionId: string,
    increment: boolean,
  ) => void;
  quantity: number;
  handleQuantityChange: (increment: boolean) => void;
  calculateTotal: () => string;
  isValidSelection: () => boolean;
  handleAddToCart: () => void;
  product: any;
  appointmentDuration: number;
  setAppointmentDuration: (duration: number) => void;
  selectedAppointmentDateTime: Date | null;
  setSelectedAppointmentDateTime: (date: Date | null) => void;
  selectedServiceProvider: EmployeeThatProvidesThisService | null;
  setSelectedServiceProvider: (
    serviceProvider: EmployeeThatProvidesThisService | null,
  ) => void;
}

const ProductOptionsWithButton: React.FC<ProductOptionsWithButtonProps> = ({
  selectionList,
  shouldShowSurcharge,
  handleOptionChange,
  quantity,
  handleQuantityChange,
  calculateTotal,
  isValidSelection,
  handleAddToCart,
  product,
  appointmentDuration,
  setAppointmentDuration,
  selectedAppointmentDateTime,
  setSelectedAppointmentDateTime,
  selectedServiceProvider,
  setSelectedServiceProvider,
}) => {
  const [showAppointmentForm, setShowAppointmentForm] = useState(false);

  const closeAppointmentForm = () => {
    setShowAppointmentForm(false);
  };

  switch (product.product_type) {
    case "Service": // Service
      return (
        <div className="flex flex-col h-full">
          {/* Replace the old scrollable div with FakeScrollbar */}
          {showAppointmentForm ? (
            <AppointmentForm
              closeAppointmentForm={closeAppointmentForm}
              product={product}
              appointmentDuration={appointmentDuration}
              handleAddToCart={handleAddToCart}
              selectedAppointmentDateTime={selectedAppointmentDateTime}
              setSelectedAppointmentDateTime={setSelectedAppointmentDateTime}
              selectedServiceProvider={selectedServiceProvider}
              setSelectedServiceProvider={setSelectedServiceProvider}
            />
          ) : (
            <>
              <Scrollbar className="flex-grow">
                <div className="md:hidden">
                  <ProductDescriptionSection product={product} />
                </div>
                {Object.entries(selectionList).length > 0 ? (
                  Object.entries(selectionList).map(([listIndex, list]) => (
                    <div key={listIndex} className="option-list">
                      <div className="mx-7 bg-[#F6F6F6] h-2 my-3"></div>
                      <div className="mx-10 flex justify-between items-center mb-3">
                        <p className="text-base font-bold">{list.name}</p>
                        {list.required && (
                          <div className="bg-grayCloud px-1 rounded-lg items-center">
                            <span className="font-bold text-sm text-[#6B6B6B]">
                              Required
                            </span>
                          </div>
                        )}
                      </div>
                      {Object.entries(list.options).map(
                        ([optionId, option]) => (
                          <div
                            className="flex justify-between mx-10"
                            key={optionId}
                          >
                            <div className="w-full items-center flex my-2.5">
                              {list.type === "checkbox" ||
                              list.type === "multiple_choice" ? (
                                <>
                                  <input
                                    type={
                                      list.type === "checkbox"
                                        ? "checkbox"
                                        : "radio"
                                    }
                                    className="appearance-none checked:bg-graySlate accent-graySlate border-2 border-graySlate w-5 h-5 focus:ring-0 focus:outline-none"
                                    style={{
                                      WebkitAppearance: "none",
                                      MozAppearance: "none",
                                      backgroundColor: option.selected
                                        ? "#545454"
                                        : "transparent",
                                    }}
                                    checked={option.selected}
                                    onChange={() => {
                                      if (product.product_type === "Service") {
                                        if (
                                          list.name.includes("Duration") ||
                                          list.name.includes("duration")
                                        ) {
                                          setAppointmentDuration(
                                            parseFloat(option.name),
                                          );
                                        }
                                      }
                                      handleOptionChange(
                                        listIndex,
                                        option.id,
                                        !option.selected,
                                      );
                                    }}
                                  />
                                  <div className="w-full ml-5 text-left flex items-center justify-between">
                                    <span className="font-semibold">
                                      {option.name}
                                    </span>
                                    {shouldShowSurcharge(option.surcharge) && (
                                      <div className="text-sm font-normal items-center">
                                        +$
                                        {parseFloat(
                                          option.surcharge.toString(),
                                        ).toFixed(2)}
                                      </div>
                                    )}
                                  </div>
                                </>
                              ) : (
                                <>
                                  {/* Increment / Decrement Buttons */}
                                  <div className="flex">
                                    <button
                                      onClick={() =>
                                        handleOptionChange(
                                          listIndex,
                                          optionId,
                                          false,
                                        )
                                      }
                                    >
                                      <DecrementIcon />
                                    </button>
                                    <span className="text-sm font-bold mx-2">
                                      {selectionList[listIndex]?.options[
                                        optionId
                                      ]?.quantity || 0}
                                    </span>
                                    <button
                                      onClick={() =>
                                        handleOptionChange(
                                          listIndex,
                                          optionId,
                                          true,
                                        )
                                      }
                                    >
                                      <IncrementIcon />
                                    </button>
                                  </div>
                                  <div className="w-full ml-5 text-left flex items-center justify-between">
                                    <span className="font-semibold">
                                      {option.name}
                                    </span>
                                    {shouldShowSurcharge(option.surcharge) && (
                                      <div className="text-sm font-normal items-center">
                                        +$
                                        {parseFloat(
                                          option.surcharge.toString(),
                                        ).toFixed(2)}
                                      </div>
                                    )}
                                  </div>
                                </>
                              )}
                            </div>
                          </div>
                        ),
                      )}
                    </div>
                  ))
                ) : (
                  <div className="flex-grow flex items-center justify-center text-gray-500">
                    {/* Optionally add a message for no content */}
                  </div>
                )}
              </Scrollbar>

              {/* Sticky footer always at the bottom */}
              <div className="md:sticky md:bg-white md:bottom-0 md:pt-1">
                <div className="w-full flex justify-center pb-12 md:pb-0">
                  <Button
                    variant="primary"
                    text={"Next"}
                    className="w-[90%] h-[3rem] md:h-[3.4rem] rounded-[6px] md:rounded-[8px] text-[16px] md:text-[18px] font-bold flex items-center justify-center"
                    onClick={() => setShowAppointmentForm(true)}
                    disabled={!isValidSelection()}
                  />
                </div>
              </div>
            </>
          )}
        </div>
      );
    default: // Physical Product
      return (
        <div className="flex flex-col h-full">
          {/* Replace the old scrollable div with FakeScrollbar */}
          <Scrollbar className="flex-grow">
            <div className="md:hidden">
              <ProductDescriptionSection product={product} />
            </div>
            {Object.entries(selectionList).length > 0 ? (
              Object.entries(selectionList).map(([listIndex, list]) => (
                <div key={listIndex} className="option-list">
                  <div className="mx-7 bg-[#F6F6F6] h-2 my-3"></div>
                  <div className="mx-10 flex justify-between items-center mb-3">
                    <p className="text-base font-bold">{list.name}</p>
                    {list.required && (
                      <div className="bg-grayCloud px-1 rounded-lg items-center">
                        <span className="font-bold text-sm text-[#6B6B6B]">
                          Required
                        </span>
                      </div>
                    )}
                  </div>
                  {Object.entries(list.options).map(([optionId, option]) => (
                    <div className="flex justify-between mx-10" key={optionId}>
                      <div className="w-full items-center flex my-2.5">
                        {list.type === "checkbox" ||
                        list.type === "multiple_choice" ? (
                          <>
                            <input
                              type={
                                list.type === "checkbox" ? "checkbox" : "radio"
                              }
                              className="appearance-none checked:bg-graySlate accent-graySlate border-2 border-graySlate w-5 h-5 focus:ring-0 focus:outline-none"
                              style={{
                                WebkitAppearance: "none",
                                MozAppearance: "none",
                                backgroundColor: option.selected
                                  ? "#545454"
                                  : "transparent",
                              }}
                              checked={option.selected}
                              onChange={() =>
                                handleOptionChange(
                                  listIndex,
                                  option.id,
                                  !option.selected,
                                )
                              }
                            />
                            <div className="w-full ml-5 text-left flex items-center justify-between">
                              <span className="font-semibold">
                                {option.name}
                              </span>
                              {shouldShowSurcharge(option.surcharge) && (
                                <div className="text-sm font-normal items-center">
                                  +$
                                  {parseFloat(
                                    option.surcharge.toString(),
                                  ).toFixed(2)}
                                </div>
                              )}
                            </div>
                          </>
                        ) : (
                          <>
                            {/* Increment / Decrement Buttons */}
                            <div className="flex">
                              <button
                                onClick={() =>
                                  handleOptionChange(listIndex, optionId, false)
                                }
                              >
                                <DecrementIcon />
                              </button>
                              <span className="text-sm font-bold mx-2">
                                {selectionList[listIndex]?.options[optionId]
                                  ?.quantity || 0}
                              </span>
                              <button
                                onClick={() =>
                                  handleOptionChange(listIndex, optionId, true)
                                }
                              >
                                <IncrementIcon />
                              </button>
                            </div>
                            <div className="w-full ml-5 text-left flex items-center justify-between">
                              <span className="font-semibold">
                                {option.name}
                              </span>
                              {shouldShowSurcharge(option.surcharge) && (
                                <div className="text-sm font-normal items-center">
                                  +$
                                  {parseFloat(
                                    option.surcharge.toString(),
                                  ).toFixed(2)}
                                </div>
                              )}
                            </div>
                          </>
                        )}
                      </div>
                    </div>
                  ))}
                </div>
              ))
            ) : (
              <div className="flex-grow flex items-center justify-center text-gray-500">
                {/* Optionally add a message for no content */}
              </div>
            )}
          </Scrollbar>

          {/* Sticky footer always at the bottom */}
          <div className="md:sticky md:bg-white md:bottom-0 md:pt-1">
            {/* Show limit info for daily specials */}
            {product.limit_per_order && (
              <div className="text-center mb-2">
                <span className="text-sm text-gray-500">
                  Limit {product.limit_per_order} per order
                  {quantity >= product.limit_per_order && (
                    <span className="text-orange-500 font-semibold ml-1">
                      (Max reached)
                    </span>
                  )}
                </span>
              </div>
            )}
            <div className="mt-2.5 mb-4 flex items-center justify-center gap-4">
              <button onClick={() => handleQuantityChange(false)}>
                <DecrementIcon className="w-10 h-10" />
              </button>
              <div className="flex items-center justify-center">
                <p className="text-lg font-bold">{quantity}</p>
              </div>
              <button
                onClick={() => handleQuantityChange(true)}
                disabled={
                  product.limit_per_order && quantity >= product.limit_per_order
                }
                className={
                  product.limit_per_order && quantity >= product.limit_per_order
                    ? "opacity-30 cursor-not-allowed"
                    : ""
                }
              >
                <IncrementIcon className="w-10 h-10" />
              </button>
            </div>

            <div className="w-full flex justify-center pb-12 md:pb-0">
              <Button
                variant="primary"
                text={
                  Number(calculateTotal()) === 0
                    ? "Priced by Add-ons"
                    : "Add to Cart US $" + calculateTotal()
                }
                className="w-[90%] h-[3rem] md:h-[3.4rem] rounded-[6px] md:rounded-[8px] text-[16px] md:text-[18px] font-bold flex items-center justify-center"
                onClick={handleAddToCart}
                disabled={!isValidSelection() || Number(calculateTotal()) === 0}
              />
            </div>
          </div>
        </div>
      );
  }
};

export default ProductOptionsWithButton;
